import type { Flag } from "@skyware-group/iris-api-model";

import { BaseClient } from "../../clients/base/BaseClient";
import type { Paged, PaginationParams } from "../_shared/pagination.types";
import { FLAGS_ENDPOINTS } from "./flags.consts";
import type { FlagCreateRequest, FlagUpdateRequest } from "./flags.types";

/**
 * Flags API Client (admin only)
 *
 * Handles CRUD for instrument-scoped flags. Identified by string `code`.
 */
export class FlagsClient extends BaseClient {
  /** Fetch a page of flags for an instrument. */
  async fetchFlags(instrumentId: number, params?: PaginationParams, signal?: AbortSignal | null): Promise<Paged<Flag>> {
    return this.get<Paged<Flag>>(FLAGS_ENDPOINTS.FLAGS(instrumentId), {
      params: params as Record<string, unknown>,
      signal,
    });
  }

  async fetchFlagByCode(instrumentId: number, code: string, signal?: AbortSignal | null): Promise<Flag> {
    return this.get<Flag>(FLAGS_ENDPOINTS.FLAG_BY_CODE(instrumentId, code), { signal });
  }

  async createFlag(instrumentId: number, data: FlagCreateRequest, signal?: AbortSignal | null): Promise<Flag> {
    return this.post<Flag>(FLAGS_ENDPOINTS.FLAGS(instrumentId), { body: data, signal });
  }

  async updateFlag(
    instrumentId: number,
    code: string,
    data: FlagUpdateRequest,
    signal?: AbortSignal | null,
  ): Promise<Flag> {
    return this.put<Flag>(FLAGS_ENDPOINTS.UPDATE_FLAG(instrumentId, code), { body: data, signal });
  }

  async deleteFlag(instrumentId: number, code: string, signal?: AbortSignal | null): Promise<void> {
    return this.delete<never>(FLAGS_ENDPOINTS.DELETE_FLAG(instrumentId, code), { signal });
  }
}
